import { SUBSCRIPTION_STATUS_CANCELLED } from '@/constants/Subscription';
import ScheduledOrderService from '@/services/subscriptions/Subscriptions/ScheduledOrderService';
import {
    filterDeliverableDays,
    filterHolidays,
    filterOptInDeliveryDays,
    filterUndeliverableDays,
} from '@/helpers/ScheduledOrderHelpers';

const getDefaultState = () => {
    return {
        deliveryDayName: null,
        cutOffDayName: null,
        firstCutOffDay: null,
        today: null,
        deliveryDays: [],
        holidays: [],
        optInDeliveryDays: [],
        haveFetched: false,
        undeliverableDays: [],
        deliverableDays: [],
        deliveries: [],
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetSelectedDeliveryDays: (state) => state.deliveryDays.map(value => { value.isSelected = false; }),

        resetState: (state) => Object.assign(state, getDefaultState()),

        selectDeliveryDay: (state, payload) => state.deliveryDays
            .filter(value => value.date === payload)
            .map(value => value.isSelected = !value.isSelected),

        updateDeliveryDayName: (state, payload) => state.deliveryDayName = payload,

        updateCutOffDayName: (state, payload) => state.cutOffDayName = payload,

        updateToday: (state, payload) => state.today = payload,

        updateDeliveryDays: (state, payload) => state.deliveryDays = payload,

        updateFirstCutOffDay: (state, payload) => state.firstCutOffDay = payload,

        updateHolidays: (state, payload) => state.holidays = payload,

        updateOptInDeliveryDays: (state, payload) => state.optInDeliveryDays = payload,

        updateUndeliverableDays: (state, payload) => state.undeliverableDays = payload,

        updateDeliverableDays: (state, payload) => state.deliverableDays = payload,

        setAllDeliveries: (state, payload) => state.deliveries = payload,
    },
    actions: {
        async fetchAllDeliveries({ commit, state, rootGetters, dispatch }, forceReload = false) {
            if (state.haveFetched === false || forceReload === true) {
                let service = new ScheduledOrderService();
                let subscription = rootGetters['subscription/getActiveSubscription'];
                let selectedDelivery = rootGetters['scheduledOrder/getSelectedDelivery'];

                if (subscription && subscription.status !== SUBSCRIPTION_STATUS_CANCELLED) {
                    state.haveFetched = true;

                    return await new Promise(function(resolve, reject) {
                        return service.fetchAllDeliveries(subscription.id)
                            .then(response => {
                                commit('setAllDeliveries', response.data.data.deliveries);
                                commit('updateDeliveryDayName', response.data.data.deliveryDayName);
                                commit('updateToday', response.data.data.today);
                                commit('updateCutOffDayName', response.data.data.cutOffDayName);

                                if (selectedDelivery) {
                                    commit('selectDelivery', selectedDelivery.datetime);
                                }

                                return resolve(response.data.data);
                            });
                    });
                }
            }
        },

        async fetchAllScheduledOrders({ commit, state, rootGetters, dispatch }, forceReload = false) {
            if (state.haveFetched === false || forceReload === true) {
                let service = new ScheduledOrderService();
                let subscription = rootGetters['subscription/getActiveSubscription'];

                if (subscription && subscription.status !== SUBSCRIPTION_STATUS_CANCELLED) {
                    state.haveFetched = true;

                    await new Promise(function(resolve, reject) {
                        service.fetchAllScheduledOrders(subscription.id)
                            .then(response => {
                                commit('setAllDeliveries', response.data.data.deliveries);
                                commit('updateHolidays', filterHolidays(response.data.data.deliveries));
                                commit('updateOptInDeliveryDays', filterOptInDeliveryDays(response.data.data.deliveries));
                                commit('updateUndeliverableDays', filterUndeliverableDays(response.data.data.deliveries));
                                commit('updateDeliverableDays', filterDeliverableDays(response.data.data.deliveries));
                                commit('updateDeliveryDayName', response.data.data.deliveryDayName);
                                commit('updateToday', response.data.data.today);
                                commit('updateCutOffDayName', response.data.data.cutOffDayName);
                            });
                    });
                }
            }
        },

        resetScheduledOrders({ commit }) {
            commit('resetState');
        },

        selectDeliveryDay({ commit, state }, selectedDay) {
            let reductor = (accumulator, value) => value.date === selectedDay || accumulator;

            if (state.deliveryDays.reduce(reductor, false) === true) {
                commit('resetSelectedDeliveryDays');
                commit('selectDeliveryDay', selectedDay);
            }
        },
    },
    getters: {
        getDeliveryDayName: state => state.deliveryDayName,

        getCutOffDayName: state => state.cutOffDayName,

        getSelectedDelivery: state => state.deliveryDays.filter(value => value.isSelected)[0],

        getToday: state => state.today,

        getDeliveryDays: state => state.deliveryDays,

        getDeliveries: state => state.deliveries,

        getFirstCutOffDay: state => state.firstCutOffDay,

        getHolidays: state => state.holidays,

        getOptInDeliveryDays: state => state.optInDeliveryDays,

        getUndeliverableDays: state => state.undeliverableDays,

        getDeliverableDays: state => state.deliverableDays,
    },
};
